import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import offerEditUIReducer from '../reducers/offerEditUIReducer';

const configureStore = (railsProps) => (
  createStore(offerEditUIReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
